import type { InputSource } from './types';

export const colorBars: InputSource = {
  label: 'Color Bars',
  value: 'colorBars',
  draw: (ctx, width, height) => {
    ctx.clearRect(0, 0, width, height);

    const bars = ['#ffffff', '#ffff00', '#00ffff', '#00ff00', '#ff00ff', '#ff0000', '#0000ff'];

    const topHeight = Math.round(height * 0.7);
    const barWidth = width / bars.length;

    for (let i = 0; i < bars.length; i += 1) {
      ctx.fillStyle = bars[i];
      ctx.fillRect(i * barWidth, 0, barWidth, topHeight);
    }

    const lowerBars = ['#003a65', '#ffffff', '#32006d', '#000000'];
    const lowerHeight = height - topHeight;
    const lowerBarWidth = width / lowerBars.length;

    for (let i = 0; i < lowerBars.length; i += 1) {
      ctx.fillStyle = lowerBars[i];
      ctx.fillRect(i * lowerBarWidth, topHeight, lowerBarWidth, lowerHeight);
    }

    ctx.strokeStyle = 'rgba(0, 0, 0, 0.6)';
    ctx.lineWidth = Math.max(2, Math.round(Math.min(width, height) * 0.002));
    ctx.strokeRect(0, 0, width, height);
  },
};
